module.exports = __webpack_public_path__ + "img/Educación.2bfcf215.svg";